import React from 'react';
import PropTypes from 'prop-types';
import suitcss from '../../../helpers/suitcss';

function ContentGroup(props) {
  const {
    item,
  } = props;

  return (
    <div
      className={suitcss({
        componentName: 'ContentGroupSplitScreen',
        className: 'TextCopy',
      })}
    >
      <div
        className={suitcss({
          componentName: 'ContentGroupSplitScreen',
          descendantName: 'row',
          className: 'u-row',
        })}
      >
        <div
          className={suitcss({
            componentName: 'cgsc',
            modifiers: ['left'],
            utilities: ['mlCol6', 'sCol12'],
          })}
        >
          <div
            className={suitcss({
              componentName: 'cgsc',
              descendantName: 'text',
              modifiers: ['left'],
            })}
          >
            <h3
              className={suitcss({
                componentName: 'cgsc',
                descendantName: 'subline',
                modifiers: [
                  'left',
                  item.leftImageDesktop && 'leftImg',
                  !item.leftImageDesktop && 'leftNoImg',
                ],
                utilities: ['marginBottomXXS'],
                className: 'TextCopy--condensed',
              })}
            >
              {item.leftHeadline}
            </h3>
            <p
              className={suitcss({
                componentName: 'cgsc',
                descendantName: 'copy',
                modifiers: ['left'],
              })}
            >
              {item.leftText}
            </p>
          </div>
          {item.leftImageDesktop
            && (
              <img
                className={suitcss({
                  componentName: 'cgsc',
                  descendantName: 'image',
                  modifiers: ['left'],
                })}
                src={item.leftImageDesktop.url}
                alt={item.leftImageDesktop.alt}
              />
            )}
          {item.leftImageMobile
            && (
              <img
                className={suitcss({
                  componentName: 'cgsc',
                  descendantName: 'imageMobile',
                  modifiers: ['left'],
                })}
                src={item.leftImageMobile.url}
                alt={item.leftImageMobile.alt}
              />
            )}
        </div>
        <div
          className={suitcss({
            componentName: 'cgsc',
            modifiers: ['right'],
            utilities: ['mlCol6', 'sCol12'],
          })}
        >
          <div
            className={suitcss({
              componentName: 'cgsc',
              descendantName: 'text',
              modifiers: ['right'],
            })}
          >
            <h3
              className={suitcss({
                componentName: 'cgsc',
                descendantName: 'subline',
                modifiers: [
                  'right',
                  item.rightImageDesktop && 'rightImg',
                  !item.rightImageDesktop && 'rightNoImg',
                ],
                utilities: ['marginBottomXXS'],
                className: 'TextCopy--condensed',
              })}
            >
              {item.rightHeadline}
            </h3>
            <p
              className={suitcss({
                componentName: 'cgsc',
                descendantName: 'copy',
                modifiers: ['right'],
              })}
            >
              {item.rightText}
            </p>
          </div>

          {item.rightImageDesktop
            && (
              <img
                className={suitcss({
                  componentName: 'cgsc',
                  descendantName: 'image',
                  modifiers: ['right'],
                })}
                src={item.rightImageDesktop.url}
                alt={item.rightImageDesktop.alt}
              />
            )}
          {item.rightImageMobile
            && (
              <img
                className={suitcss({
                  componentName: 'cgsc',
                  descendantName: 'imageMobile',
                  modifiers: ['right'],
                })}
                src={item.rightImageMobile.url}
                alt={item.rightImageMobile.alt}
              />
            )}

        </div>
      </div>
    </div>
  );
}

ContentGroup.propTypes = {
  item: PropTypes.object,
};

ContentGroup.defaultProps = {};

export default ContentGroup;
